module.exports = __webpack_public_path__ + "static/index/img/baikal-111.0dd814bd.jpg";